exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.h2_title[data-v-ebd1865a] {\n  text-align: left;\n  color: grey;\n}\n.btn-grabar[data-v-ebd1865a] {\n  background-color: #ff6c00 !important;\n}\n", ""]);

// exports
